import { getSettings, setSettings } from "./sessionDraftStorage";

export function sortStickies(stickies, origin) {
  const mirror = stickies.filter((s) => s.origin_board_type !== origin);
  mirror.sort((a, b) => a.name.localeCompare(b.name));
  const origins = stickies.filter((s) => s.origin_board_type === origin);
  origins.sort((a, b) => (a.index || 0) - (b.index || 0));
  return origins.concat(mirror);
}

export function saveLocalSettings(settings) {
  setSettings({ ...getSettings(), ...settings });
}
